export default __webpack_public_path__ + "static/media/Tasset of Crimson Slaughter (nm).ce957ba0.jpg";